export default {
  data() {
    return {
      canvas: null, // canvas对象
      context: null, // canvas上下文
    }
  },
  methods: {
    async initCanvas() {
      this.canvas = this.$refs.canvas
      await this.draw()
      // 进行导出base64
      this.shareImg = this.canvas.toDataURL('image/jpeg')
    },
    draw() {
      return new Promise((resolve, reject) => {
        let w = document.documentElement.clientWidth
        let h = w + 80
        // 设置canvas尺寸
        let devicePixelRatio = window.devicePixelRatio
        this.canvas.width = w * devicePixelRatio
        this.canvas.height = h * devicePixelRatio
        this.canvas.style.width = w + 'px'
        this.canvas.style.height = h + 'px'
        // 获取画笔
        this.context = this.canvas.getContext('2d')
        this.context.setTransform(devicePixelRatio, 0, 0, devicePixelRatio, 0, 0)
        // 设置canvas底色
        this.context.fillStyle = '#fff'
        this.context.fillRect(0, 0, w, h)
        this.qrImg.onload = () => {
          this.context.drawImage(this.qrImg, 0, 0, this.qrImg.width, this.qrImg.height, w / 4, 125, w / 2, w / 2)
          // 设置字体
          this.context.font = "18px bold 黑体"
          // 设置对齐方式
          this.context.textAlign = 'center';
          // 设置颜色
          this.context.fillStyle = "#333"
          this.context.fillText('恭喜您获得「音乐全球通」代理注册邀请', w / 2, 20)
          this.context.fillText('如有任何问题，请联络您的直属服务人员', w / 2, 178 + w / 2)

          // 设置字体
          this.context.font = "20px bold 黑体"
          this.context.fillText('  请在收到本二维码2小时内完成注册，', w / 2, 60)
          this.context.fillText('  否则本邀请将会失效                         ', w / 2, 85)
          // 设置字体
          this.context.font = "16px bold 黑体"
          // 设置对齐方式
          this.context.textAlign = 'center';
          this.context.fillText('手机号码：' + JSON.parse(localStorage.getItem('generateAgentUsreInfo')).phone, w / 2, w + 20)
          this.context.fillText('(长按图片识别二维码)', w / 2, w + 50)
          resolve()
        }
        this.qrImg.onerror= error => {
          reject(error)
        }
      })
    },
    share() {
      this.$store.commit('TOGGLE_LOADING', true)
      try {
        window.uni.postMessage({
          data: {
            type: 'share',
            img: this.shareImg
          }
        })
      } finally {
        this.$store.commit('TOGGLE_LOADING', false)
      }
    },
    saveImg() {
      try {
        this.$store.commit('TOGGLE_LOADING', true)
        window.uni.postMessage({
          data: {
            type: 'saveImg',
            img: this.shareImg
          }
        })
      } finally {
        this.$store.commit('TOGGLE_LOADING', false)
      }
    }
  }
}
